import { discoveryRequest, processDiscoveryResponse } from 'oauth4webapi';
export const getAuthorizationServerInfo = async (issuerUrl) => {
    const response = await discoveryRequest(issuerUrl, {
        algorithm: 'oidc',
    });
    return await processDiscoveryResponse(issuerUrl, response);
};
